import { combineReducers } from 'redux';
import { metamaskReducer } from './Metamask';
import { modalReducer } from './Modal';

export const rootReducer = combineReducers({
  metamask: metamaskReducer,
  modal: modalReducer,
});
